// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { ChevronUp } from "feather-icons-react/build/IconComponents";
// import { setToogleHeader } from "../../core/redux/action";
// import { useDispatch, useSelector } from "react-redux";
// import Loader from "../loader/loader";
// import React, { useState, useEffect, useRef } from "react";
// import { useToast } from "../../Toaster/ToastContext";
// import { apiClient } from "../../services/apiClient";
// import { Table } from "antd";

// const PurchaseOrderReport = () => {
//   const dispatch = useDispatch();
//   const data = useSelector((state) => state.toggle_header);
//   const [purchases, setPurchases] = useState([]);
//   const [filteredPurchases, setFilteredPurchases] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { showToast } = useToast();
//   const hasFetched = useRef(false);

//   const fetchPurchaseOrders = async () => {
//     if (hasFetched.current) return;
//     setLoading(true);
//     try {
//       const response = await apiClient.post("/get-all-purchase-order", {
//         pageIndex: 0,
//         pageSize: 50,
//         previousPageIndex: 0,
//       });
//       if (response.success) {
//         // setPurchases(response.purchases);
//         // setFilteredPurchases(response.purchases);
//         const flattenedData = response.data.flatMap((purchase) =>
//           purchase.items.map((item, index) => ({
//             id: `${purchase.id}-${index}`,
//             invoice_no: purchase.invoice_no,
//             date: purchase.date,
//             product_name: item.product_name,
//             purchased_amount: parseFloat(
//               (item.purchased_amount || "0").toString().replace(/,/g, "")
//             ),
//             purchased_quantity: item.purchased_quantity || 0,
//             instock_quantity: item.instock_quantity || 0,
//           }))
//         );

//         setPurchases(flattenedData);
//         setFilteredPurchases(flattenedData);
//       } else {
//         setPurchases([]);
//         setFilteredPurchases([]);
//       }
//     } catch (error) {
//       showToast(
//         error.message || "Failed to fetch purchases",
//         "error",
//         "Purchases"
//       );
//     } finally {
//       setLoading(false);
//       hasFetched.current = true;
//     }
//   };

//   useEffect(() => {
//     fetchPurchaseOrders();
//   }, []);

//   const handleSearch = (e) => {
//     const term = e.target.value.toLowerCase();

//     setFilteredPurchases(
//       purchases.filter((purchase) => {
//         const invoiceNo = (purchase.invoice_no || "").toLowerCase();
//         const productName = (purchase.product_name || "").toLowerCase();
//         return invoiceNo.includes(term) || productName.includes(term);
//       })
//     );
//   };

//   const renderCollapseTooltip = (props) => (
//     <Tooltip id="refresh-tooltip" {...props}>
//       Collapse
//     </Tooltip>
//   );

//   const columns = [
//     {
//       title: "Invoice No",
//       dataIndex: "invoice_no",
//       render: (text) => <span className="wrap-text">{text}</span>,
//       sorter: (a, b) =>
//         (a.invoice_no || "").length - (b.invoice_no || "").length,
//       width: 200,
//     },
//     {
//       title: "Date",
//       dataIndex: "date",
//       sorter: (a, b) => new Date(a.date) - new Date(b.date),
//       render: (text) => {
//         const date = new Date(text);
//         return isNaN(date)
//           ? "N/A"
//           : date
//               .toLocaleDateString("en-GB", {
//                 day: "2-digit",
//                 month: "2-digit",
//                 year: "numeric",
//               })
//               .split("/")
//               .join("-");
//       },
//       width: 150,
//     },
//     {
//       title: "Product Name",
//       dataIndex: "product_name",
//       sorter: (a, b) =>
//         (a.product_name || "").length - (b.product_name || "").length,
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       width: 200,
//     },
//     {
//       title: "Purchased Amount",
//       dataIndex: "purchased_amount",
//       sorter: (a, b) => (a.purchased_amount || 0) - (b.purchased_amount || 0),
//       render: (text) => <span className="wrap-text">PKR {text || "0.00"}</span>,
//       width: 150,
//     },
//     {
//       title: "Purchased Quantity",
//       dataIndex: "purchased_quantity",
//       sorter: (a, b) =>
//         (a.purchased_quantity || 0) - (b.purchased_quantity || 0),
//       render: (text) => <span className="wrap-text">{text || 0}</span>,
//       width: 150,
//     },
//     {
//       title: "In Stock Quantity",
//       dataIndex: "instock_quantity",
//       sorter: (a, b) => (a.instock_quantity || 0) - (b.instock_quantity || 0),
//       render: (text) => <span className="wrap-text">{text || 0}</span>,
//       width: 150,
//     },
//   ];

//   return (
//     <div>
//       <Loader loading={loading} />
//       <div
//         className="page-wrapper"
//         style={{ position: "relative", minHeight: "100vh" }}
//       >
//         <div className="content">
//           <div className="page-header">
//             <div className="add-item d-flex">
//               <div className="page-title">
//                 <h4>Purchase order report</h4>
//                 <h6>Manage your Purchase order report</h6>
//               </div>
//             </div>
//             <ul className="table-top-head">
//               <li>
//                 <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
//                   <Link
//                     data-bs-toggle="tooltip"
//                     data-bs-placement="top"
//                     id="collapse-header"
//                     className={data ? "active" : ""}
//                     onClick={() => {
//                       dispatch(setToogleHeader(!data));
//                     }}
//                   >
//                     <ChevronUp />
//                   </Link>
//                 </OverlayTrigger>
//               </li>
//             </ul>
//           </div>
//           {/* /product list */}
//           <div className="card">
//             <div className="card-body">
//               <div className="table-top">
//                 <div className="search-set">
//                   <div className="search-input">
//                     <input
//                       type="text"
//                       placeholder="Search by invoice no and product name"
//                       className="form-control form-control-sm formsearch"
//                       onChange={handleSearch}
//                     />
//                     <Link to className="btn btn-searchset">
//                       <i data-feather="search" className="feather-search" />
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//               {/* <div className="table-responsive">
//                 <table className="table datanew">
//                   <thead>
//                     <tr>
//                       <th>Invoice No</th>
//                       <th>Date</th>
//                       <th>Product Name</th>
//                       <th>Purchased Amount</th>
//                       <th>Purchased Quantity</th>
//                       <th>In Stock Quantity</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredPurchases.length > 0 ? (
//                       filteredPurchases.map((purchase, purchaseIndex) => (
//                         purchase.items?.map((item, itemIndex) => (
//                           <tr key={`${purchaseIndex}-${itemIndex}`}>
//                             {itemIndex === 0 && (
//                               <td rowSpan={purchase.items.length}>{purchase.invoice_no}</td>
//                             )}
//                             {itemIndex === 0 && (
//                               <td rowSpan={purchase.items.length}>
//                                 {purchase.date
//                                   ? purchase.date.split('-').reverse().join('-')
//                                 : 'N/A'}
//                               </td>
//                             )}
//                             <td>{item.product_name || 'N/A'}</td>
//                             <td>${item.purchased_amount || '0.00'}</td>
//                             <td>{item.purchased_quantity || 0}</td>
//                             <td>{item.instock_quantity || 0}</td>
//                           </tr>
//                         ))
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="12" className="text-center">
//                           No purchases found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div> */}
//               <div className="table-responsive">
//                 <Table
//                   columns={columns}
//                   dataSource={filteredPurchases}
//                   rowKey={(record) => record.id}
//                   rowSelection={null}
//                 />
//               </div>
//             </div>
//           </div>
//           {/* /product list */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PurchaseOrderReport;

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../loader/loader";
import React, { useState, useEffect, useRef } from "react";
import { useToast } from "../../Toaster/ToastContext";
import { apiClient } from "../../services/apiClient";
import { Table } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const PurchaseOrderReport = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [purchases, setPurchases] = useState([]);
  const [filteredPurchases, setFilteredPurchases] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const hasFetched = useRef(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalCount: 0,
  });

  const fetchPurchaseOrders = async (currentPage = 1, pageSize = 20, force = false) => {
    if (hasFetched.current && !force) return;
    setLoading(true);
    const pageIndex = currentPage - 1;
    try {
      const response = await apiClient.post("/get-all-purchase-order", {
        pageIndex,
        pageSize,
        previousPageIndex: 0,
      });
      if (response.success) {
        const groupedData = response.data.reduce((acc, purchase) => {
          purchase.items.forEach((item, index) => {
            acc.push({
              id: `${purchase.id}-${index}`,
              invoice_no: purchase.invoice_no,
              date: purchase.date,
              product_name: item.product_name,
              purchased_amount: parseFloat(
                (item.purchased_amount || "0").toString().replace(/,/g, "")
              ),
              purchased_quantity: item.purchased_quantity || 0,
              instock_quantity: item.instock_quantity || 0,
              isMainRow: index === 0,
            });
          });
          return acc;
        }, []);

        setPurchases(groupedData);
        setFilteredPurchases(groupedData);
        setPagination({
          currentPage: response.currentPage ?? currentPage,
          pageSize: response.pageSize ?? pageSize,
          totalPages: response.totalPages ?? 1,
          totalCount: response.totalCount || groupedData.length,
        });
      } else {
        setPurchases([]);
        setFilteredPurchases([]);
        setPagination({
          currentPage: 1,
          pageSize: 20,
          totalPages: 0,
          totalCount: 0,
        });
      }
    } catch (error) {
      showToast(
        error.message || "Failed to fetch purchases",
        "error",
        "Purchases"
      );
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      fetchPurchaseOrders(pagination.currentPage, pagination.pageSize);
    }
  }, [pagination.currentPage, pagination.pageSize]);

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
    hasFetched.current = false;
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();

    setFilteredPurchases(
      purchases.filter((purchase) => {
        const invoiceNo = (purchase.invoice_no || "").toLowerCase();
        const productName = (purchase.product_name || "").toLowerCase();
        return invoiceNo.includes(term) || productName.includes(term);
      })
    );
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      render: (text, record) => (
        <span className="wrap-text">{record.isMainRow ? text : ""}</span>
      ),
      sorter: (a, b) =>
        (a.invoice_no || "").length - (b.invoice_no || "").length,
      width: 200,
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text, record) => (
        <span className="wrap-text">
        {record.isMainRow
          ? new Date(text).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          .split("/")
          .join("-")
        : ""}
    </span>
  ),
  sorter: (a, b) => new Date(a.date) - new Date(b.date),
  width: 150,
},
    {
      title: "Product Name",
      dataIndex: "product_name",
      sorter: (a, b) =>
        (a.product_name || "").length - (b.product_name || "").length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 200,
    },
    {
      title: "Purchased Amount",
      dataIndex: "purchased_amount",
      sorter: (a, b) => (a.purchased_amount || 0) - (b.purchased_amount || 0),
      render: (text) => <span className="wrap-text">PKR {text || "0.00"}</span>,
      width: 150,
    },
    {
      title: "Purchased Quantity",
      dataIndex: "purchased_quantity",
      sorter: (a, b) =>
        (a.purchased_quantity || 0) - (b.purchased_quantity || 0),
      render: (text) => <span className="wrap-text">{text || 0}</span>,
      width: 150,
    },
    {
      title: "In Stock Quantity",
      dataIndex: "instock_quantity",
      sorter: (a, b) => (a.instock_quantity || 0) - (b.instock_quantity || 0),
      render: (text) => <span className="wrap-text">{text || 0}</span>,
      width: 150,
    },
  ];

  const { currentPage, pageSize, totalPages, totalCount } = pagination;
  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalCount);

  const pagesToShow = [];
  if (totalPages > 0) {
    if (totalPages <= 2) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (currentPage === 1) {
        middle = [1, 2];
      } else if (currentPage === totalPages) {
        middle = [totalPages - 1, totalPages];
      } else {
        middle = [currentPage, currentPage + 1];
      }

      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < totalPages - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < totalPages) {
        pagesToShow.push(totalPages);
      }
    }
  }

  const changePage = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
    hasFetched.current = false;
  };

  return (
    <div>
      <Loader loading={loading} />
      <div
        className="page-wrapper"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Purchase order report</h4>
                <h6>Manage your Purchase order report</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search by invoice no and product name"
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredPurchases}
                  rowKey={(record) => record.id}
                  rowSelection={null}
                  pagination={false}
                />
              </div>
              {totalCount > 0 && (
                <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4">
                  <div className="pagination-left">
                    Showing {startItem} - {endItem} of {totalCount}
                  </div>
                  <div className="pagination-right d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      disabled={currentPage === 1}
                      onClick={() => changePage(currentPage - 1)}
                    >
                      <LeftOutlined size={12} />
                    </button>
                    {pagesToShow.map((page, index) => (
                      <span key={index} className="me-2">
                        {page === "..." ? (
                          <span className="pagination-ellipsis">...</span>
                        ) : (
                          <button
                            className={`btn btn-sm ${
                              page === currentPage
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => changePage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </span>
                    ))}
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      disabled={currentPage === totalPages}
                      onClick={() => changePage(currentPage + 1)}
                    >
                      <RightOutlined size={12} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderReport;
